<template>
  <div class="ibox">
    <div class="ibox-title"><h5>用户管理</h5></div>
    <div class="ibox-content">
    <div class="crud-bar">
      <el-input v-model="keyword" placeholder="昵称 / 手机号" style="width:260px" @keyup.enter.native="search">
        <el-button slot="append" icon="el-icon-search" @click="search" />
      </el-input>
    </div>
    <el-table :data="pagedList" v-loading="loading" border stripe>
      <el-table-column prop="id" label="ID" width="70" />
      <el-table-column prop="nickName" label="昵称" />
      <el-table-column prop="tel" label="手机号" width="140" />
      <el-table-column label="VIP" width="90">
        <template slot-scope="s">
          <el-tag :type="s.row.vip === '2' ? 'success' : (s.row.vip === '3' ? 'danger' : 'info')">
            {{ s.row.vip === '2' ? 'VIP' : (s.row.vip === '3' ? '禁用' : '普通') }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="express_time" label="会员到期" width="170" />
      <el-table-column prop="updated_at" label="最近更新" width="170" />
      <el-table-column label="操作" width="240">
        <template slot-scope="s">
          <el-button size="mini" @click="openSetup(s.row)">权限设置</el-button>
          <el-button size="mini" type="danger" @click="onDisable(s.row)">{{ s.row.vip === '3' ? '解禁' : '禁用' }}</el-button>
          <el-button size="mini" type="warning" @click="onToBlacklist(s.row)">黑名单</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pager">
      <el-pagination
        layout="total, prev, pager, next, jumper"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="total"
        @current-change="handleCurrentChange"
      />
    </div>

    <el-dialog title="权限设置" :visible.sync="dialogVisible" width="460px">
      <el-form :model="form" label-width="100px">
        <el-form-item label="昵称"><el-input v-model="form.nickName" disabled /></el-form-item>
        <el-form-item label="会员到期">
          <el-date-picker v-model="form.express_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期" />
        </el-form-item>
        <el-form-item label="虚星到期"><el-date-picker v-model="form.xuxing" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" /></el-form-item>
        <el-form-item label="本命到期"><el-date-picker v-model="form.benming" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" /></el-form-item>
        <el-form-item label="力量到期"><el-date-picker v-model="form.liliang" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" /></el-form-item>
        <el-form-item label="和谐到期"><el-date-picker v-model="form.hexie" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" /></el-form-item>
        <el-form-item label="中点到期"><el-date-picker v-model="form.zhongdian" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" /></el-form-item>
        <el-form-item label="点报警到期"><el-date-picker v-model="form.pointAlarm" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" /></el-form-item>
        <el-form-item label="面报警到期"><el-date-picker v-model="form.areaAlarm" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" /></el-form-item>
        <el-form-item label="恒星配置权限到期"><el-date-picker v-model="form.starControl" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" /></el-form-item>
        <el-form-item label="行星配置权限到期"><el-date-picker v-model="form.planetControl" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" /></el-form-item>
        <el-form-item label="逻辑点权限到期"><el-date-picker v-model="form.logicPointControl" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" /></el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="onSave">保存</el-button>
      </div>
    </el-dialog>
    </div>
  </div>
</template>

<script>
import { usersApi } from '../api/business'

export default {
  name: 'AdminUsers',
  data () {
    return {
      list: [],
      loading: false,
      keyword: '',
      currentPage: 1,
      pageSize: 10,
      dialogVisible: false,
      saving: false,
      form: {}
    }
  },
  computed: {
    total () { return this.list.length },
    totalPages () { return Math.max(1, Math.ceil(this.total / this.pageSize)) },
    pagedList () {
      const start = (this.currentPage - 1) * this.pageSize
      return this.list.slice(start, start + this.pageSize)
    }
  },
  watch: {
    totalPages (val) { if (this.currentPage > val) this.currentPage = val }
  },
  created () { this.fetch() },
  methods: {
    async fetch () {
      this.loading = true
      try { this.list = await usersApi.list(this.keyword) } catch (e) { this.$message.error(e.uiMessage || e.message) } finally { this.loading = false }
    },
    search () {
      this.currentPage = 1
      this.fetch()
    },
    handleCurrentChange (page) {
      this.currentPage = page
    },
    openSetup (row) {
      this.form = { ...row }
      this.dialogVisible = true
    },
    async onSave () {
      this.saving = true
      try {
        // el-date-picker 清空时把 v-model 置为 null，而后端用 @Body Map 接收请求体时
        // 会把值为 null 的键丢掉（null 与「没提交该字段」无法区分），于是清空不生效。
        // 这里统一把空值转成空字符串，后端按「空串 = 清空该列」处理（与老 PHP 后台一致）。
        const expiry = (value) => (value === null || value === undefined ? '' : value)
        await usersApi.setup(this.form.id, {
          express_time: expiry(this.form.express_time),
          xuxing: expiry(this.form.xuxing),
          benming: expiry(this.form.benming),
          liliang: expiry(this.form.liliang),
          hexie: expiry(this.form.hexie),
          zhongdian: expiry(this.form.zhongdian),
          pointAlarm: expiry(this.form.pointAlarm),
          areaAlarm: expiry(this.form.areaAlarm),
          starControl: expiry(this.form.starControl),
          planetControl: expiry(this.form.planetControl),
          logicPointControl: expiry(this.form.logicPointControl),
          vip: this.form.vip
        })
        this.$message.success('已保存'); this.dialogVisible = false; this.fetch()
      } catch (e) { this.$message.error(e.uiMessage || e.message) } finally { this.saving = false }
    },
    async onDisable (row) {
      const vip = row.vip === '3' ? '1' : '3'
      const tip = vip === '3' ? '禁用该用户？' : '解除禁用？'
      if (!await this.$confirm(tip, '提示', { type: 'warning' }).catch(() => false)) return
      try {
        await usersApi.disable(row.id, vip)
        this.$message.success('操作成功'); this.fetch()
      } catch (e) { this.$message.error(e.uiMessage || e.message) }
    },
    // 移入黑名单：将该用户整行转移到 user_blacklist 表
    async onToBlacklist (row) {
      if (!await this.$confirm(`将「${row.nickName || row.id}」移入黑名单？移入后将从用户列表转移到黑名单列表。`, '提示', { type: 'warning' }).catch(() => false)) return
      try {
        await usersApi.toBlacklist(row.id)
        this.$message.success('已移入黑名单'); this.fetch()
      } catch (e) { this.$message.error(e.uiMessage || e.message) }
    }
  }
}
</script>

<style scoped>
.crud-bar { margin-bottom: 16px; }
.pager {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}
</style>
